// extracted by css-extract-rspack-plugin
export default {"wrapper":"HeaderUser-module__wrapper--wKRfY","color-override":"HeaderUser-module__color-override--oIYSI","colorOverride":"HeaderUser-module__color-override--oIYSI"};